import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "pb-3 text-left" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "text-left"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: "existInsuranceLabel",
  class: "pb-3 text-left",
  textContent: 'Hvilket forsikringsselskab var du senest hos?'
}
const _hoisted_7 = ["textContent"]
const _hoisted_8 = { key: "formerInsurance2" }
const _hoisted_9 = {
  key: "formerInsuranceErr",
  class: "text-left"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: "existFormerInsuranceLabel",
  class: "pb-3 text-left",
  textContent: 'Hvilket forsikringsselskab var du senest hos?'
}
const _hoisted_13 = {
  class: "pb-3 pt-3 text-left",
  textContent: 'Hvornår skal forsikringen gælde fra?',
  key: "validNowLabel"
}
const _hoisted_14 = { key: "validNow" }
const _hoisted_15 = {
  key: "validNowErr",
  class: "text-left"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg en af ovenstående'
}, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  key: "insuranceTerminationInfoBox",
  class: "highlights fill mb-4 mt-3"
}
const _hoisted_19 = { class: "text-left" }
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", {
  class: "pb-3 pt-3 text-left",
  textContent: 'Hvor mange skader har du haft på dine forsikringer de seneste 2 år?'
}, null, -1)
const _hoisted_22 = {
  class: "text-left mt-n3 mb-3",
  key: "skaderErr"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg antal skader'
}, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = {
  key: "RkiLabel",
  class: "pb-3 text-left"
}
const _hoisted_26 = {
  key: "rkiErr",
  class: "text-left"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_28 = [
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopoverComponent = _resolveComponent("PopoverComponent")!
  const _component_RadioComponent = _resolveComponent("RadioComponent")!
  const _component_SelectModalComponent = _resolveComponent("SelectModalComponent")!
  const _component_DatePickerComponent = _resolveComponent("DatePickerComponent")!
  const _component_SegmentedControlComponent = _resolveComponent("SegmentedControlComponent")!
  const _component_ButtonTapComponent = _resolveComponent("ButtonTapComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", { innerHTML: _ctx.existingInsuranceLabel }, null, 8, _hoisted_2),
        (_ctx.cms.terminationInfoPopover)
          ? (_openBlock(), _createBlock(_component_PopoverComponent, {
              key: 0,
              type: "icon",
              class: "page-component__popover",
              buttonClass: "popover__icon popover__icon__info",
              innerData: _ctx.cms.terminationInfoPopover
            }, null, 8, ["innerData"]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
          key: 'existInsurance' + inx
        }, [
          _createVNode(_component_RadioComponent, {
            name: 'existInsurance',
            id: 'existInsurance' + item.value,
            inputValue: item.value,
            preSelect: _ctx.model.additionalInfo.existInsurance,
            trackingLabel: _ctx.existingInsuranceLabel,
            onRadioComponent: _ctx.handleRadioClick
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.displayValue), 1)
            ]),
            _: 2
          }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
        ], 2))
      }), 128)),
      (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.additionalInfo.existInsurance)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (_ctx.model.additionalInfo.existInsurance === 'ja')
          ? (_openBlock(), _createElementBlock("div", _hoisted_6))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_SelectModalComponent, {
          key: "existingInsurance",
          id: "existingInsurance",
          name: "existingInsurance",
          preSelect: _ctx.model.additionalInfo.existingInsurance,
          innerData: _ctx.cms.insuranceCompanies,
          selected: _ctx.model.additionalInfo.existingInsurance !== undefined,
          placeholder: "Vælg forsikringsselskab",
          visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
          errorMsgOverride: "Du skal vælge et forsikringsselskab",
          "onSelectModalComponent:selected": _ctx.selectExistingInsurance
        }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"]), [
          [_vShow, _ctx.model.additionalInfo.existInsurance === 'ja']
        ]),
        (_ctx.showFormerInsurance && _ctx.model.additionalInfo.existInsurance === 'nej')
          ? (_openBlock(), _createElementBlock("div", {
              class: "pb-3 pt-3 text-left",
              textContent: _toDisplayString('Har du haft en ' + _ctx.model.productName + ' før?'),
              key: "formerInsurance1"
            }, null, 8, _hoisted_7))
          : _createCommentVNode("", true),
        (_ctx.model.additionalInfo.existInsurance === 'nej' && _ctx.showFormerInsurance)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
                  key: 'existFormerInsurance' + inx
                }, [
                  _createVNode(_component_RadioComponent, {
                    name: 'existFormerInsurance',
                    id: 'existFormerInsurance' + item.value,
                    inputValue: item.value,
                    preSelect: _ctx.model.additionalInfo.existFormerInsurance,
                    trackingLabel: 'Har du haft en ' + _ctx.model.productName + ' før?',
                    onRadioComponent: _ctx.handleRadioClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.displayValue), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
                ], 2))
              }), 128)),
              (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.additionalInfo.existFormerInsurance)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (
					_ctx.showFormerInsurance &&
					_ctx.model.additionalInfo.existFormerInsurance === 'ja' &&
					_ctx.model.additionalInfo.existInsurance === 'nej'
				)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12))
          : _createCommentVNode("", true),
        (
					_ctx.showFormerInsurance &&
					_ctx.model.additionalInfo.existFormerInsurance === 'ja' &&
					_ctx.model.additionalInfo.existInsurance === 'nej'
				)
          ? (_openBlock(), _createBlock(_component_SelectModalComponent, {
              key: "formerInsurance",
              id: "formerInsurance",
              name: "formerInsurance",
              preSelect: _ctx.model.additionalInfo.formerInsurance,
              innerData: _ctx.cms.insuranceCompanies,
              selected: _ctx.model.additionalInfo.formerInsurance !== undefined,
              placeholder: "Vælg selskab",
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
              errorMsgOverride: "Du skal vælge et forsikringsselskab",
              "onSelectModalComponent:selected": _ctx.selectFormerInsurance
            }, null, 8, ["preSelect", "innerData", "selected", "visibleError", "onSelectModalComponent:selected"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_TransitionGroup, { name: "slide-simple" }, {
      default: _withCtx(() => [
        (_ctx.showValidNowOption)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13))
          : _createCommentVNode("", true),
        (_ctx.showValidNowOption)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validNowArray, (item, inx) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([inx + 1 === _ctx.validNowArray.length ? 'pb-3' : 'pb-2']),
                  key: 'validNow' + inx
                }, [
                  _createVNode(_component_RadioComponent, {
                    name: "validNow",
                    id: 'validNow' + item.value,
                    inputValue: item.value,
                    preSelect: _ctx.model.additionalInfo.validNow,
                    trackingLabel: "Hvornår skal forsikringen gælde fra?",
                    onRadioComponent: _ctx.handleRadioClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.displayValue), 1)
                    ]),
                    _: 2
                  }, 1032, ["id", "inputValue", "preSelect", "onRadioComponent"])
                ], 2))
              }), 128)),
              (!_ctx.model.pristineStep.get(_ctx.card.name) && !_ctx.model.additionalInfo.validNow)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, _hoisted_17))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("span", {
                    innerHTML: _ctx.cms.insuranceTerminationInfoBox
                  }, null, 8, _hoisted_20)
                ])
              ], 512), [
                [_vShow, _ctx.showValidNowOption && _ctx.cms.insuranceTerminationInfoBox]
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.model.additionalInfo.validNow === 'nej' && _ctx.showValidNowOption)
          ? (_openBlock(), _createBlock(_component_DatePickerComponent, {
              key: "validFromDate",
              class: "text-left mb-3",
              label: "",
              innerId: "validFromDate",
              innerData: _ctx.model.additionalInfo,
              placeholder: "F.eks. 21-12-2020",
              validateOnLoad: !_ctx.model.pristineStep.get(_ctx.card.name),
              validationRule: "AfterToday",
              visibleError: !_ctx.model.pristineStep.get(_ctx.card.name),
              dateLimitIncluded: true
            }, null, 8, ["innerData", "validateOnLoad", "visibleError"]))
          : _createCommentVNode("", true),
        _withDirectives(_createVNode(_component_SegmentedControlComponent, {
          key: "skader",
          class: "pb-3",
          id: "skader",
          options: _ctx.skaderOptions,
          labels: _ctx.skaderLabels,
          preSelected: _ctx.model.additionalInfo.skader,
          controlsPerRow: 4,
          onSegmentedComponent: _ctx.handleRadioClick
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }, 8, ["options", "labels", "preSelected", "onSegmentedComponent"]), [
          [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled]
        ]),
        (
					!_ctx.model.pristineStep.get(_ctx.card.name) &&
					!_ctx.model.multipleProducts &&
					_ctx.isInsuranceInfoFilled &&
					!_ctx.model.additionalInfo.skader
				)
          ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_25, [
          _createElementVNode("span", null, _toDisplayString(_ctx.cms.rkiHeader), 1),
          (_ctx.cms.rkiPopover)
            ? (_openBlock(), _createBlock(_component_PopoverComponent, {
                key: 0,
                type: "icon",
                class: "page-component__popover text-left",
                buttonClass: "popover__icon popover__icon_info",
                innerData: _ctx.cms.rkiPopover
              }, null, 8, ["innerData"]))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
          return _withDirectives((_openBlock(), _createElementBlock("div", {
            class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
            key: 'rki' + inx
          }, [
            _createVNode(_component_RadioComponent, {
              name: "rki",
              id: 'rki' + item.value,
              inputValue: item.value,
              preSelect: _ctx.model.additionalInfo.rki,
              trackingLabel: _ctx.cms.rkiHeader,
              onRadioComponent: _ctx.handleRadioClick
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.displayValue), 1)
              ]),
              _: 2
            }, 1032, ["id", "inputValue", "preSelect", "trackingLabel", "onRadioComponent"])
          ], 2)), [
            [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
          ])
        }), 128)),
        (!_ctx.model.pristineStep.get(_ctx.card.name) && _ctx.model.additionalInfo.rki === undefined)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, _hoisted_28, 512)), [
              [_vShow, !_ctx.model.multipleProducts && _ctx.isInsuranceInfoFilled && _ctx.skaderOk]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_ButtonTapComponent, {
      class: _normalizeClass([_ctx.card.buttonStyle, 'mt-3', { 'btn-disabled': !_ctx.isValid }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.nextStep())),
      "data-gtm": _ctx.cms.dataGtm,
      "data-gtm-click-text": _ctx.card.routePath
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.getNextCardLinkText()), 1)
      ]),
      _: 1
    }, 8, ["class", "data-gtm", "data-gtm-click-text"])
  ]))
}